import { render, staticRenderFns } from "./Brightness.vue?vue&type=template&id=3116ea2d&"
import script from "./Brightness.vue?vue&type=script&lang=js&"
export * from "./Brightness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports